// Service Steady PWA — src/hooks/useBodyScrollLock.ts — v1.0 — built 2026-06-04
//
// iOS Safari + PWA-safe body scroll lock.
//
// `overflow: hidden` alone DOES NOT prevent the body behind a modal from
// scrolling on iOS Safari / iOS PWA. The reliable cross-browser pattern is:
//   1. capture current window.scrollY
//   2. position the body fixed at -scrollY so its visible viewport stays
//      where the user was
//   3. on unlock, restore the body styles AND window.scrollTo(0, scrollY)
//
// Without this, opening WeatherDetailModal on an iOS home-screen PWA leaves
// the Today page free to scroll underneath, and on close the body has
// jumped to the top.

import { useEffect } from 'react';

export function useBodyScrollLock(active: boolean): void {
  useEffect(() => {
    if (!active || typeof document === 'undefined') return;
    const scrollY = window.scrollY;
    const body = document.body;
    const prev = {
      overflow: body.style.overflow,
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width,
    };
    body.style.overflow = 'hidden';
    body.style.position = 'fixed';
    body.style.top = `-${scrollY}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    return () => {
      body.style.overflow = prev.overflow;
      body.style.position = prev.position;
      body.style.top = prev.top;
      body.style.left = prev.left;
      body.style.right = prev.right;
      body.style.width = prev.width;
      window.scrollTo(0, scrollY);
    };
  }, [active]);
}
